import {
   SET_NOTIFICATIONS_DATA,
   SET_UNREAD_NOTIFICATION_COUNT
  } from '../types/types';
  
  export const setNotifications = (value, count) => {
    return {
      type: SET_NOTIFICATIONS_DATA,
      payload: { data: value},
    };
  };
  
  export const setUnreadNotificationCount = (value) => {
    return {
      type: SET_UNREAD_NOTIFICATION_COUNT,
      payload: { data: value },
    };
  };